import { ReviewOrUpdateEmailModalComponent } from '../review-or-update-email-modal/review-or-update-email-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ChangePolicyEmailComponent } from '../change-policy-email/change-policy-email.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { UserDataService } from '../../../../../../_services/data-services/user-data.service';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { EmailService } from '../../../../../../_services/email/email.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, ChangePolicyEmailComponent, MapfreButtonComponent, ReviewOrUpdateEmailModalComponent],
  selector: 'app-email-doesnt-match-the-account',
  templateUrl: './email-doesnt-match-the-account.component.html',
  styleUrls: ['./email-doesnt-match-the-account.component.scss'],
})
export class EmailDoesntMatchTheAccountComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  uploadingFiles: ModalOptions;
  showReviewUpdateEmail: boolean;
  userDetails;
  policyId: string;
  policyEmail: string;
  emailMask: string;
  isAcmic = false;
  constructor(
    private userDataService: UserDataService,
    private activatedRoute: ActivatedRoute,
    private emailService: EmailService,
    private acmicService: AcmicService
  ) {
    this.showReviewUpdateEmail = false;
    this.uploadingFiles = new ModalOptions({
      additionalClasses: 'modal-lg modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'policyEmailDoesnotMatchEmail',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: '',
      modalName: 'policy_email_doesnot_match_email',
    });
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.policyId = params['id'];
      this.policyEmail = params['emailId'];
      this.emailMask = this.emailService.maskEmail(this.policyEmail);
    });
    this.getUserData();
  }
  updateAccountEmailAddress() {
    this.showReviewUpdateEmail = true;
  }
  closeModal() {
    this.showReviewUpdateEmail = false;
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.userDetails = user.userDetails;
      }
    });
  }
}
